import { Link } from 'react-router-dom';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import Contact from '../../home/components/Contact';
import WhatsAppDiagnostic from '../../home/components/WhatsAppDiagnostic';

export default function FenetresDoubleVitrageLyon() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-600 via-indigo-500 to-purple-500 pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <i className="ri-window-2-line text-white"></i>
              <span className="text-white text-sm font-medium">Guide Double Vitrage 2025</span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight">
              Fenêtres Double Vitrage Lyon
            </h1>
            
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Tout savoir sur les fenêtres double vitrage à Lyon. Avantages, prix, performances et conseils d'installation pour votre projet de rénovation.
            </p>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <article className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Fenêtres Double Vitrage Lyon : Guide Complet 2025
            </h2>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Le double vitrage est devenu la norme pour les fenêtres à Lyon. Obligatoire dans les constructions neuves depuis 2006, il offre des performances thermiques et phoniques incomparables. Ce guide vous explique tout ce que vous devez savoir sur les fenêtres double vitrage à Lyon.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Qu'est-ce que le Double Vitrage ?
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Le double vitrage est composé de deux vitres séparées par une lame d'air ou de gaz (argon ou krypton). Cette composition est notée 4/16/4 par exemple : 4mm de verre, 16mm d'espace, 4mm de verre. L'espace entre les vitres crée une barrière thermique et phonique très efficace.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Les Différents Types de Double Vitrage
            </h3>
            
            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Double Vitrage Standard (4/16/4)
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Le double vitrage standard offre déjà d'excellentes performances : coefficient Ug = 1.1 W/m².K, réduction du bruit de 25 à 30 dB. C'est le minimum obligatoire et le plus économique. Prix moyen à Lyon : 250€ à 400€ par fenêtre installée.
            </p>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Double Vitrage à Isolation Renforcée (VIR)
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Le VIR intègre une couche faiblement émissive et du gaz argon. Performances supérieures : Ug = 0.9 W/m².K, économies d'énergie de 30% supplémentaires. Recommandé à Lyon pour un confort optimal. Prix : 300€ à 500€ par fenêtre.
            </p>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Double Vitrage Phonique
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Spécialement conçu pour l'isolation acoustique avec des verres d'épaisseurs différentes (10/10/4 par exemple). Réduction du bruit jusqu'à 40 dB. Indispensable en centre-ville de Lyon, près des axes routiers ou de l'aéroport. Prix : 350€ à 550€.
            </p>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Double Vitrage de Sécurité
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Intègre un verre feuilleté anti-effraction. Retarde l'intrusion de plusieurs minutes. Recommandé pour les rez-de-chaussée et maisons isolées à Lyon. Prix : 400€ à 600€ par fenêtre.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Avantages du Double Vitrage à Lyon
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Économies d'énergie :</strong> Réduction de 30% de la facture de chauffage</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Confort thermique :</strong> Température homogène, suppression de l'effet paroi froide</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Isolation phonique :</strong> Réduction du bruit extérieur de 25 à 40 dB</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Suppression de la condensation :</strong> Fini les vitres embuées en hiver</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Valorisation immobilière :</strong> Augmentation de la valeur de votre bien</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Sécurité renforcée :</strong> Plus difficile à briser qu'un simple vitrage</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Prix des Fenêtres Double Vitrage à Lyon
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Les prix varient selon le matériau, les dimensions et le type de vitrage :
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-price-tag-3-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Fenêtre PVC double vitrage :</strong> 300€ à 800€ pose comprise</span>
              </li>
              <li className="flex items-start">
                <i className="ri-price-tag-3-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Fenêtre alu double vitrage :</strong> 500€ à 1200€ pose comprise</span>
              </li>
              <li className="flex items-start">
                <i className="ri-price-tag-3-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Fenêtre bois double vitrage :</strong> 400€ à 1000€ pose comprise</span>
              </li>
              <li className="flex items-start">
                <i className="ri-price-tag-3-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Baie vitrée double vitrage :</strong> 800€ à 2500€ selon dimensions</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Remplacement Simple Vitrage par Double Vitrage
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Si vous avez encore du simple vitrage à Lyon, le remplacement par du double vitrage est fortement recommandé. Deux options s'offrent à vous :
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-arrow-right-s-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Remplacement du vitrage seul :</strong> 150€ à 300€ par fenêtre, si le châssis est en bon état</span>
              </li>
              <li className="flex items-start">
                <i className="ri-arrow-right-s-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Remplacement complet :</strong> 300€ à 800€, recommandé si châssis ancien (+ de 20 ans)</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Double Vitrage vs Triple Vitrage
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Le triple vitrage offre de meilleures performances thermiques (Ug = 0.6 W/m².K) mais présente des inconvénients à Lyon :
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-close-circle-line text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Prix élevé :</strong> 50% plus cher que le double vitrage</span>
              </li>
              <li className="flex items-start">
                <i className="ri-close-circle-line text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Poids important :</strong> Nécessite des châssis renforcés</span>
              </li>
              <li className="flex items-start">
                <i className="ri-close-circle-line text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Moins de luminosité :</strong> Transmission lumineuse réduite de 10%</span>
              </li>
              <li className="flex items-start">
                <i className="ri-close-circle-line text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Rentabilité discutable :</strong> Climat lyonnais ne justifie pas le surcoût</span>
              </li>
            </ul>

            <p className="text-gray-700 leading-relaxed mb-6">
              Pour Lyon, le double vitrage à isolation renforcée (VIR) offre le meilleur compromis performance/prix/luminosité.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Aides Financières pour le Double Vitrage
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-gift-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>MaPrimeRénov' :</strong> 40€ à 100€ par fenêtre selon revenus</span>
              </li>
              <li className="flex items-start">
                <i className="ri-gift-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>CEE :</strong> Prime énergie variable selon travaux</span>
              </li>
              <li className="flex items-start">
                <i className="ri-gift-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Éco-PTZ :</strong> Prêt à taux zéro jusqu'à 15 000€</span>
              </li>
              <li className="flex items-start">
                <i className="ri-gift-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>TVA 5.5% :</strong> Au lieu de 20% avec artisan RGE</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Conseils pour Choisir son Double Vitrage à Lyon
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-lightbulb-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Centre-ville :</strong> Privilégiez le double vitrage phonique (réduction 35-40 dB)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-lightbulb-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Exposition sud :</strong> Optez pour un vitrage à contrôle solaire</span>
              </li>
              <li className="flex items-start">
                <i className="ri-lightbulb-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Rez-de-chaussée :</strong> Choisissez un vitrage feuilleté anti-effraction</span>
              </li>
              <li className="flex items-start">
                <i className="ri-lightbulb-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Budget serré :</strong> PVC + double vitrage standard = meilleur rapport qualité-prix</span>
              </li>
              <li className="flex items-start">
                <i className="ri-lightbulb-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Performance maximale :</strong> PVC + VIR argon = isolation optimale</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Conclusion
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Le double vitrage est un investissement rentable à Lyon. Il améliore votre confort, réduit vos factures d'énergie et valorise votre bien immobilier. Pour la plupart des logements lyonnais, nous recommandons le double vitrage à isolation renforcée (VIR) avec châssis PVC. N'oubliez pas de faire appel à un professionnel RGE pour bénéficier des aides financières.
            </p>
          </article>
        </div>
      </section>

      {/* WhatsApp Diagnostic */}
      <WhatsAppDiagnostic />

      {/* Contact */}
      <Contact />
      
      <Footer />
    </div>
  );
}
